import type { DccMarkupRateColumnFilters, DccRateFormState } from '../models/types';

export const EMPTY_DCC_RATE_FORM: DccRateFormState = {
  fromCurrency: '',
  toCurrency: '',
  rate: '',
  notes: '',
};

export const EMPTY_DCC_MARKUP_RATE_COLUMN_FILTERS: DccMarkupRateColumnFilters = {
  pair: null,
  rateLabel: null,
  status: null,
  notes: null,
  createdAt: null,
};
